import React, { useState } from 'react';

import { Row, Col } from 'react-bootstrap';
import { useParams, useNavigate } from 'react-router-dom';
import { validatePermission } from 'actions/index';

import Modal from 'v3/components/Modal';
import Button from 'v3/components/Button';
import Text from 'v3/components/Text';

import { useClient } from '../../shared/context';

function Created({ isOpen, onClose }) {
  const client = useClient();
  const navigate = useNavigate();

  const [hasPermissionToCreate, setPermissionToCreate] = useState();

  useState(() => {
    setPermissionToCreate(validatePermission('CADASTRAR_CLIENTES'));
  }, []);

  return (
    <>
      <Modal
        show={isOpen}
        onHide={onClose}
        heading="Cadastro de clientes"
        body={
          <Row className="mx-0 mt-1">
            <Text weight="400" color="dark">
              Cliente {client.data.social_name} cadastrado com sucesso!
            </Text>
          </Row>
        }
        footer={
          <div
            className="mr-3 mt-1"
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-end',
              flexWrap: 'wrap',
              gap: '8px',
            }}
          >
            <Button
              variant="white"
              className="mt-1"
              outlined
              size="sm"
              onClick={() => navigate('/clientes')}
            >
              <Text weight="500">Ver listagem</Text>
            </Button>

            <Button
              className="mt-1"
              variant="primary"
              size="sm"
              onClick={() => navigate(`/clientes/${client?.data?.id}`)}
            >
              <Text weight="500">Ver cliente</Text>
            </Button>

            {hasPermissionToCreate && (
              <Button
                variant="success"
                className="mt-1"
                size="sm"
                onClick={() => {
                  window.location.reload(false);
                }}
              >
                <Text weight="500">Novo cliente</Text>
              </Button>
            )}
          </div>
        }
      />
    </>
  );
}

export default Created;
